import React from 'react';
import SideMenu from './menuComponents/SideMenu';
import BreadCrumb from './commonComponents/BreadCrumb';

const Layout = ({ children }) => {
  return (
    <div id="container">
      <div className="inner in-between">
        <SideMenu />
        <div className="contents">
          <BreadCrumb />
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
